"use client";

import React from "react";
import { Wind, Snowflake, Fan, Thermometer } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const systems = [{
  title: "VRF Systems",
  description: "Experience ultimate precision with simultaneous heating and cooling designed for high-performance commercial environments.",
  icon: Wind,
  badge: "High Efficiency"
}, {
  title: "Wall-mounted Split",
  description: "Enjoy versatile and cost-effective climate control tailored for individual rooms and smaller professional spaces.",
  icon: Snowflake,
  badge: "Cost-effective"
}, {
  title: "Ducted Systems",
  description: "Achieve seamless, invisible comfort with hidden units that deliver perfectly balanced temperatures throughout your building.",
  icon: Fan,
  badge: "Quiet Operation"
}, {
  title: "Cassette Split",
  description: "Optimise your open-plan space with 360-degree airflow distribution designed for modern suspended ceiling installations.",
  icon: Thermometer,
  badge: "Eco-Friendly"
}];
export default function HvacSystemShowcase() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hvacsystemshowcase" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`max-w-4xl mb-16 md:mb-20 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground mb-6 tracking-tight">
            Air conditioning systems we work with
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl">
            Our expertise covers various types of air conditioning systems to suit any space or specification:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {systems.map((system, index) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          const isEven = index % 2 === 1;
          return <div key={index} data-index={index} ref={cardRef} className={`transition-all duration-700 ease-out`} style={{
            opacity: isCardVisible ? 1 : 0,
            transform: isCardVisible ? 'translateY(0)' : 'translateY(32px)',
            transitionDelay: `${index * 100}ms`
          }}>
                <Card className={`h-full relative group hover:-translate-y-2 hover:shadow-xl transition-all duration-500 border-border/50 bg-gradient-to-br from-card to-muted/30 overflow-hidden`}>
                  {}
                  <div className="absolute top-4 right-4 z-10">
                    <span className="inline-flex items-center rounded-lg bg-primary/10 px-2.5 py-0.5 text-xs font-semibold text-primary border border-primary/20">
                      {system.badge}
                    </span>
                  </div>

                  <div className={`flex flex-col sm:flex-row ${isEven ? 'sm:flex-row-reverse' : 'flex-row'} h-full items-center sm:items-start gap-2`}>
                    <CardHeader className="flex-shrink-0 pt-8 sm:pt-6">
                      
                    </CardHeader>
                    
                    <div className="flex flex-col justify-center py-6 pr-6 pl-6 sm:pl-0">
                      <CardTitle className="font-default text-2xl text-card-foreground mb-3">
                        {system.title}
                      </CardTitle>
                      <CardContent className="p-0">
                        <p className="text-muted-foreground text-base leading-relaxed">
                          {system.description}
                        </p>
                      </CardContent>
                    </div>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}